<template>
  <div>错误页面</div>

</template>

<script>
    export default {
        name: "error"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/error/error.vue